import script from "./MailOtpConfirmationModal.vue?vue&type=script&setup=true&lang=js"
export * from "./MailOtpConfirmationModal.vue?vue&type=script&setup=true&lang=js"

import "./MailOtpConfirmationModal.vue?vue&type=style&index=0&id=2cc6e4e8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2cc6e4e8"]])

export default __exports__